import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';

export const HomeRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const activeRole = authService.role();

  switch (activeRole) {
    case 'ROLE_ROOT':
      return router.createUrlTree(['/root-admin']);

    case 'ROLE_ADMIN':
      return router.createUrlTree(['/admin']);

    case 'ROLE_MANAGER':
    case 'ROLE_STAFF':
      return router.createUrlTree(['/employee']);

    default:
      return true;
  }
};
